import { render, staticRenderFns } from "./StudioMyFavorites.vue?vue&type=template&id=41028afa&scoped=true&"
import script from "./StudioMyFavorites.vue?vue&type=script&lang=js&"
export * from "./StudioMyFavorites.vue?vue&type=script&lang=js&"
import style0 from "./StudioMyFavorites.vue?vue&type=style&index=0&id=41028afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41028afa",
  null
  
)

export default component.exports